import { Action } from 'queries/cases/types';

export const actionsFilter = (actions: Action[]) => {
  return actions.filter((action) => action && !action.deleted);
};
